import React from 'react';

export const CostReductionSVG = () => (
    <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <filter id="glow">
                <feGaussianBlur stdDeviation="2" result="coloredBlur" />
                <feMerge>
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>

        {/* Main bot head */}
        <rect
            x="120"
            y="100"
            width="160"
            height="160"
            rx="40"
            fill="white"
            stroke="#e2e8f0"
            stroke-width="4"
        />

        {/* Bot eyes */}
        <circle
            cx="170"
            cy="160"
            r="15"
            fill="#e2e8f0"
        >
            <animate
                attributeName="r"
                values="15;12;15"
                dur="3s"
                repeatCount="indefinite"
            />
        </circle>
        <circle
            cx="230"
            cy="160"
            r="15"
            fill="#e2e8f0"
        >
            <animate
                attributeName="r"
                values="15;12;15"
                dur="3s"
                repeatCount="indefinite"
            />
        </circle>

        {/* Antenna */}
        <circle
            cx="200"
            cy="80"
            r="10"
            fill="white"
            stroke="#e2e8f0"
            stroke-width="4"
        />
        <line
            x1="200"
            y1="90"
            x2="200"
            y2="100"
            stroke="#e2e8f0"
            stroke-width="4"
        />

        {/* Speech bubbles */}
        <g filter="url(#glow)">
            {/* Left bubble */}
            <rect
                x="40"
                y="140"
                width="50"
                height="30"
                rx="15"
                fill="white"
                stroke="#e2e8f0"
                stroke-width="3"
            >
                <animate
                    attributeName="opacity"
                    values="0;1;0"
                    dur="4s"
                    repeatCount="indefinite"
                />
            </rect>

            {/* Right bubble */}
            <rect
                x="310"
                y="140"
                width="50"
                height="30"
                rx="15"
                fill="white"
                stroke="#e2e8f0"
                stroke-width="3"
            >
                <animate
                    attributeName="opacity"
                    values="0;1;0"
                    dur="4s"
                    begin="2s"
                    repeatCount="indefinite"
                />
            </rect>
        </g>

        {/* Bot neck/body */}
        <rect
            x="180"
            y="260"
            width="40"
            height="40"
            fill="white"
            stroke="#e2e8f0"
            stroke-width="4"
        />
    </svg>
);

export const InstantSupportSVG = () => (
    <svg viewBox="0 0 400 300" className="w-full h-full">
        <defs>
            <filter id="softGlow">
                <feGaussianBlur stdDeviation="2" result="coloredBlur" />
                <feMerge>
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>

        <g transform="translate(200, 150)">
            {/* Network Nodes and Connections */}
            {[0, 1, 2, 3, 4, 5].map((i) => {
                const angle = (i * 60) * (Math.PI / 180);
                const radius = 80;
                const x = Math.cos(angle) * radius;
                const y = Math.sin(angle) * radius;

                return (
                    <g key={i}>
                        {/* Connection Lines */}
                        <line
                            x1="0"
                            y1="0"
                            x2={x}
                            y2={y}
                            stroke="#e2e8f0"
                            strokeWidth="2"
                            strokeDasharray="4 4"
                        />

                        {/* Animated Data Dots */}
                        <circle r="3" fill="#e2e8f0">
                            <animateMotion
                                path={`M0,0 L${x},${y}`}
                                dur="2s"
                                begin={`${i * 0.3}s`}
                                repeatCount="indefinite"
                            />
                        </circle>

                        {/* Outer Nodes */}
                        <g transform={`translate(${x}, ${y})`}>
                            {/* Outer glow */}
                            <circle
                                r="15"
                                fill="white"
                                stroke="#e2e8f0"
                                strokeWidth="2"
                                filter="url(#softGlow)"
                            >
                                <animate
                                    attributeName="r"
                                    values="15;17;15"
                                    dur="2s"
                                    begin={`${i * 0.2}s`}
                                    repeatCount="indefinite"
                                />
                            </circle>

                            {/* Inner circle */}
                            <circle
                                r="8"
                                fill="white"
                                stroke="#e2e8f0"
                                strokeWidth="2"
                            />
                        </g>
                    </g>
                );
            })}

            {/* Central Hub */}
            <g filter="url(#softGlow)">
                {/* Outer ring */}
                <circle
                    r="25"
                    fill="white"
                    stroke="#e2e8f0"
                    strokeWidth="2"
                >
                    <animate
                        attributeName="r"
                        values="25;27;25"
                        dur="3s"
                        repeatCount="indefinite"
                    />
                </circle>

                {/* Middle ring */}
                <circle
                    r="18"
                    fill="white"
                    stroke="#e2e8f0"
                    strokeWidth="2"
                />

                {/* Center */}
                <circle
                    r="10"
                    fill="white"
                    stroke="#e2e8f0"
                    strokeWidth="2"
                />
            </g>
        </g>
    </svg>
);


export const GrowthChartSVG = () => (
    <svg viewBox="0 0 400 300" className="w-full h-full">
        <defs>
            <clipPath id="growthArea">
                <path d="M50,250 C150,250 250,100 350,50 L350,250 L50,250 Z" />
            </clipPath>
            <filter id="softGlow">
                <feGaussianBlur stdDeviation="2" result="coloredBlur" />
                <feMerge>
                    <feMergeNode in="coloredBlur" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>

        <g transform="translate(0, 0)">
            {/* Background Grid */}
            <g>
                {[0, 1, 2, 3, 4].map((i) => (
                    <line
                        key={`h${i}`}
                        x1="50"
                        y1={50 + i * 50}
                        x2="350"
                        y2={50 + i * 50}
                        stroke="#e2e8f0"
                        strokeWidth="1"
                        strokeDasharray="4 4"
                        opacity="0.5"
                    />
                ))}
                {[0, 1, 2, 3].map((i) => (
                    <line
                        key={`v${i}`}
                        x1={50 + i * 100}
                        y1="50"
                        x2={50 + i * 100}
                        y2="250"
                        stroke="#e2e8f0"
                        strokeWidth="1"
                        strokeDasharray="4 4"
                        opacity="0.5"
                    />
                ))}
            </g>

            {/* Growth Area */}
            <path
                d="M50,250 C150,250 250,100 350,50 L350,250 L50,250 Z"
                fill="#e2e8f0"
                opacity="0.1"
                filter="url(#softGlow)"
            >
                <animate
                    attributeName="d"
                    values="
            M50,250 C150,250 250,100 350,50 L350,250 L50,250 Z;
            M50,250 C150,240 250,90 350,40 L350,250 L50,250 Z;
            M50,250 C150,250 250,100 350,50 L350,250 L50,250 Z
          "
                    dur="4s"
                    repeatCount="indefinite"
                />
            </path>

            {/* Growth Line */}
            <path
                d="M50,250 C150,250 250,100 350,50"
                fill="none"
                stroke="#e2e8f0"
                strokeWidth="3"
                filter="url(#softGlow)"
            >
                <animate
                    attributeName="d"
                    values="
            M50,250 C150,250 250,100 350,50;
            M50,250 C150,240 250,90 350,40;
            M50,250 C150,250 250,100 350,50
          "
                    dur="4s"
                    repeatCount="indefinite"
                />
            </path>

            {/* Data Points */}
            {[0, 1, 2, 3].map((i) => {
                const x = 50 + i * 100;
                const y = 250 - i * 60;
                return (
                    <g key={i}>
                        {/* Outer circle with glow */}
                        <circle
                            cx={x}
                            cy={y}
                            r="12"
                            fill="white"
                            stroke="#e2e8f0"
                            strokeWidth="2"
                            filter="url(#softGlow)"
                        >
                            <animate
                                attributeName="cy"
                                values={`${y};${y - 10};${y}`}
                                dur="4s"
                                begin={`${i * 0.5}s`}
                                repeatCount="indefinite"
                            />
                            <animate
                                attributeName="r"
                                values="12;14;12"
                                dur="2s"
                                begin={`${i * 0.5}s`}
                                repeatCount="indefinite"
                            />
                        </circle>
                        {/* Inner circle */}
                        <circle
                            cx={x}
                            cy={y}
                            r="6"
                            fill="white"
                            stroke="#e2e8f0"
                            strokeWidth="2"
                        >
                            <animate
                                attributeName="cy"
                                values={`${y};${y - 10};${y}`}
                                dur="4s"
                                begin={`${i * 0.5}s`}
                                repeatCount="indefinite"
                            />
                        </circle>
                    </g>
                );
            })}

            {/* KPI Indicators */}
            {[0, 1, 2].map((i) => {
                const x = 350;
                const y = 80 + i * 50;
                return (
                    <g key={i} transform={`translate(${x}, ${y})`}>
                        <circle
                            r="8"
                            fill="white"
                            stroke="#e2e8f0"
                            strokeWidth="2"
                            filter="url(#softGlow)"
                        >
                            <animate
                                attributeName="r"
                                values="8;10;8"
                                dur="2s"
                                begin={`${i * 0.3}s`}
                                repeatCount="indefinite"
                            />
                        </circle>
                        <circle
                            r="4"
                            fill="white"
                            stroke="#e2e8f0"
                            strokeWidth="2"
                        />
                    </g>
                );
            })}
        </g>
    </svg>
);
export default {
    CostReductionSVG,
    InstantSupportSVG,
    GrowthChartSVG
};